import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../store/app.states';
import { ComponentBase } from '../component-base';
import { OnDestroy } from '@angular/core';
import { NgwWowService } from 'ngx-wow';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { getNewEmployeeView_Model } from 'src/app/modules/shared/components/new-employee-view/selectors';

@Component({
  selector: 'app-new-employee-details-view',
  templateUrl: './new-employee-view.component.html',
  styleUrls: ['./new-employee-view.component.scss'],
  host: {
    class: 'w-100'
  }
})
export class NewEmployeeDetailsViewComponent extends ComponentBase implements OnInit, OnDestroy {
  employeeId: number = 0;
  data$ = this.store.pipe(select(getNewEmployeeView_Model));

  constructor(public store: Store<AppState>,
    public activatedRoute: ActivatedRoute,
    private wowService: NgwWowService,
    private router: Router
  ) {
    super();

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(event => {
      this.wowService.init();
    });

  }
  certificateOfEmploymentId
  ngOnInit() {
    super.ngOnInitBase();

    this.getRouteParam(this.activatedRoute, 'id', (id) => {
      this.employeeId = id;
    });

    this.screenWidthChange(this.store, (width: number) => {

    });
  }

  ngOnDestroy() {
    super.ngOnDestroyBase();
  }
}
